import React, { useState } from 'react';

const cardStyle = {
  backgroundColor: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.08)',
  borderLeft: '3px solid #1d4ed8',
  overflow: 'hidden',
  fontFamily: "'DM Sans', sans-serif",
};

const Controls = ({
  filterStatus, setFilterStatus,
  filterAircraftModel, setFilterAircraftModel,
  filterDataset, setFilterDataset,
  aircraftModels, filteredCount, totalCount,
  isPremium, onPremiumFeatureClick,
  topOffset = 64
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleAircraftModelChange = (e) => {
    const val = e.target.value;
    if (!isPremium && val !== 'all') { setFilterAircraftModel('all'); onPremiumFeatureClick(); return; }
    setFilterAircraftModel(val);
  };

  const handleDatasetClick = (val) => {
    if (!isPremium && val === '10days') { onPremiumFeatureClick(); return; }
    setFilterDataset(val);
  };

  const statusOptions = [
    { value: 'all', label: 'All' },
    { value: 'arrived', label: 'Arrived' },
    { value: 'departed', label: 'Departed' },
  ];

  return (
    <div className="absolute left-4 z-50" style={{ top: `${topOffset}px`, width: '238px' }}>
      <div style={cardStyle}>

        {/* ── Collapsed ── entire card is one button, no padding wrapper */}
        {!isExpanded && (
          <button
            onClick={() => setIsExpanded(true)}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '10px 16px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f9fafb'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
          >
            <span style={{ fontWeight: 500, fontSize: '14px', color: '#111111' }}>Filters</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>
        )}

        {/* ── Expanded ── */}
        {isExpanded && (
          <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: '9px' }}>

            {/* Header row — same pattern as StatsBar */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 600, fontSize: '14px', color: '#111111' }}>Filters</span>
              <button
                onClick={() => setIsExpanded(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '4px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: "'DM Sans', sans-serif",
                }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="18 15 12 9 6 15"/>
                </svg>
              </button>
            </div>

            {/* Status chips */}
            <div className="sia-filter-row">
              {statusOptions.map(opt => (
                <button
                  key={opt.value}
                  className={`sia-chip${filterStatus === opt.value ? ' active' : ''}`}
                  onClick={() => setFilterStatus(opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            <div className="sia-filter-divider" />

            {/* Aircraft + dataset row */}
            <div className="sia-filter-bottom">
              <div style={{ position: 'relative', flex: 1 }}>
                <select
                  className="sia-aircraft-select"
                  value={filterAircraftModel}
                  onChange={handleAircraftModelChange}
                >
                  <option value="all">All models</option>
                  {aircraftModels
                    .filter(m => !m.endsWith('F'))
                    .map(m => (
                      <option key={m} value={m} disabled={!isPremium}>{m}</option>
                    ))}
                </select>
              </div>

              <div className="sia-segmented">
                <button
                  className={`sia-seg-btn${filterDataset === '5days' ? ' active' : ''}`}
                  onClick={() => handleDatasetClick('5days')}
                >
                  5d
                </button>
                <button
                  className={`sia-seg-btn${filterDataset === '10days' ? ' active' : ''}${!isPremium ? ' locked' : ''}`}
                  onClick={() => handleDatasetClick('10days')}
                >
                  15d
                  {!isPremium && (
                    <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <div className="sia-filter-divider" />

            <div className="sia-filter-count" style={{ textAlign: 'center' }}>
              <span>{filteredCount}</span> of <span>{totalCount}</span> flights
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Controls;
